import {valueSchema, validationSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'product_levels'

export const dataPointDefinition = {
  retracedId: 'product_levels',
  name: 'Product Levels',
  description: 'Select the product levels this company sells',
  meta: {
    asset: 'PRODUCT_LEVELS',
    constantsValidation: true,
  },
  fieldTypeId: 'MULTI_SELECT',
  type: 'RELATIONAL',
  options: [],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'array',
        items: {
          type: 'object',
          properties: {
            id: {
              type: 'string',
            },
          },
          required: ['id'],
        },
      },
    },
    required: ['value'],
  },
  externalIds: [],
  sortingId: 230,
  sectionId: '1.1',
  impactArea: 'About',
  impactAreaId: 'ABOUT',
}

export const validateSchema = async (data, {validatorFn}) => {
  try {
    validate({value: data, schema: valueSchema})

    if (!validatorFn) {
      throw new Error(`missing constants function`)
    }

    if (typeof validatorFn !== 'function') {
      throw new Error(`expect constants function to be a function, got ${typeof validatorFn}`)
    }

    const validConstants = await validatorFn()
    validate({value: validConstants, schema: validationSchema})
    const constantsId = validConstants.map(constant => constant.id)
    let value = data.value

    if (dataPointDefinition.schema.properties.value.type !== 'array') {
      value = [{id: value}]
    }

    const isValueAcceptable = value.every(entry => constantsId.includes(entry.id))
    if (!isValueAcceptable) throw new Error(`the value was invalid`)

    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
